/**
 * Represents the possible site plan types supported on the map.
 */
export default class SitePlanType {
  
  /**
   * It represents the absence of a site plan.
   */
  static get None() {
    return this.getInstance('None');
  }

  /**
   * It represents the Static Plans.
   */
  static get Static() {
    return this.getInstance('Static');
  }

  /**
   * It represents the Interactive Plans.
   */
  static get Interactive() {
    return this.getInstance('Interactive');
  }

  static fromKey(key) {
    const map = {
      None: SitePlanType.None,
      Static: SitePlanType.Static,
      Interactive: SitePlanType.Interactive,
    };
    return map[key];
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new SitePlanType(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(SitePlanType, 'instances', { value: {} });
